// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"7756c663","338":"2c8b8f46"}[chunkId] + ".chunk.js";
};